<template>
  <div>
    <v-toolbar
      class="removeBtnPaddingRight"
      color="#DADADA"
      elevation="1"
      flat
    >
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="isLoading"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.size"
      :server-items-length="count"
      :options.sync="options"
      :footer-props="{'items-per-page-options':[10,50,100]}"
      class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.created="{item}">
        <span>{{correctTime(item.created)}}</span>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="updateData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {displayDate} from "@/helper";

export default {
  name: "AdminOrdersLogStatusList",
  components: {},
  mixins: [PaginatedDataMapperMixin],
  data() {
    return {
      headers: [
        {text: "Новый статус", value: "new_status", sortable: false, align: "start", width: "20%"},
        {text: "Старый статус", value: "old_status", sortable: true, align: "center", width: "20%"},
        {text: "Инициатор", value: "initiator", sortable: true, align: "center", width: "40%"},
        {text: "Дата изменения", value: "created", sortable: true, align: "center", width: "20%"}
      ]
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      items: "admin/getLogStatusList",
      count: "admin/getLogStatusCount",
      isLoading: "admin/isLoadingLogStatus"
    })
  },
  methods: {
    ...mapActions({
      loadLogList: "admin/loadLogStatusList"
    }),
    correctTime (time, minute = true) {
      if(time !==null)
        return displayDate(time, minute)
    },
    updateData(){
      this.loadData()
    },
    loadData(url=undefined){
      this.loadLogList({
        url: url,
        id: this.$route.params.idOrders,
        urlAppend: (url) => {
          return this.addSizeParameter(url);
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    }
  },
  created() {
    this.loadData(undefined)
  }
}
</script>

<style scoped>
.removeBtnPaddingRight >>> .v-toolbar__content {
  padding-right: 0px;
}
</style>
